// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__nIxGu","form":"styles_form__3pZBo"};